import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { selectStyle } from '../../utils/styleUtils';
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select';
import _ from 'lodash';
import { setNotificationData } from '../../redux/global/globalReducer';
import { useDispatch } from 'react-redux';


function TruckMaintenanceModal({
  modal,
  setModal,
  toggle,
  truckOptions,
  truckCreationInformation,
  setTruckCreationInformation,
  toggleFormCancelDisplay,
  args
}) {
  const dispatch = useDispatch();
  const { register, handleSubmit, setValue, setError, clearErrors, reset, setFocus, control, formState: { errors, isDirty } } = useForm();

  const onTruckSelectChange = (e) => {
    setTruckCreationInformation(e);
  }

  const openFormAndCloseModal = () => {
    if (truckCreationInformation === null) {
      dispatch(
        setNotificationData({
          type: `error`,
          message: `Error!`,
          description: `Please select a truck`,
        })
      );
      return
    }
    toggleFormCancelDisplay();
    toggle();
  }

  const resetValue = () => {
    setTruckCreationInformation(null);
  }

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Create a Truck Maintenance</ModalHeader>
        <ModalBody>
          <form className="row form-container justify-content-center align-items-center" id="TruckMaintenance-form" >
            {/* <div className="col-6 col-sm-4 mb-2"></div> */}
            <div className="col-8 col-sm-6 mb-2">
              <label htmlFor="truckId" className="form-label">Truck</label>
              <div className="custom-selector">
                <Controller
                  name="truck"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      onChange={(e) => { field.onChange(e); onTruckSelectChange(e) }}
                      value={truckCreationInformation}
                      options={truckOptions}
                      className="company-select"
                      classnameprefix="react-select"
                      placeholder={'Truck'}
                      id="truck"
                      styles={selectStyle}
                      isclearable="true"
                      tabIndex={11}
                    />
                  )}
                />
              </div>
              <small className='form-error-message'>
                {errors?.companyName && errors.companyName.message}
              </small>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={openFormAndCloseModal}>
            Create Truck Maintenance
          </Button>
        </ModalFooter>
      </Modal>
    </>

  )
}

export default TruckMaintenanceModal